<template>
  <div class="customer-management-clinch">
    <div class="title">成交客户
      <span>共 <b>{{ total || 0 }}</b> 个客户</span>
    </div>
    <div class="subject">
      <div class="search">
        <!-- 固定搜索条件 -->
        <div class="fixed">
          <div class="left">
            <div class="search-item search-item-special">
              <el-select
                size="small"
                v-model="searchData.keySelectValue"
                slot="prepend"
                placeholder="请选择"
                @change="keySelectChange"
              >
                <el-option
                  v-for="item in keywordOptions"
                  :label="item.name"
                  :value="item.key"
                  :key="item.key"
                ></el-option>
              </el-select>
              <el-input
                v-if="searchData.keySelectValue"
                placeholder="客户名称/联系人姓名/手机/邮箱/备注"
                v-model="searchData.keyword"
                class="input-with-select"
                size="small"
                clearable
                @keyup.enter.native="search"
              >
                <el-button
                  size="small"
                  slot="append"
                  icon="iconfont icon-icon-fangdajing"
                  @click="search"
                ></el-button>
              </el-input>
              <div class="select-btn" v-else>
                <el-select
                  size="small"
                  multiple
                  filterable
                  collapse-tags
                  v-model="searchData.tags"
                  clearable
                >
                  <el-option
                    v-for="item in tagList"
                    :key="item.id"
                    :value="item.id"
                    :label="item.name"
                  >
                  </el-option>
                </el-select>
                <el-button size="small"   @click="search">
                  <i class="iconfont icon-icon-fangdajing "></i>
                </el-button>
              </div>
            </div>
            <div class="search-item">
              <div class="search-item">
                <div class="specialFocus" @click="attentionChange">
                  <i
                    class="iconfont icon-icon-shoucang"
                    style="color: #ff7f2a"
                    v-if="attentionStatus == 20"
                  ></i>
                  <i class="iconfont icon-icon-shoucangxianxing" v-else></i>
                  <span>特别关注</span>
                </div>
              </div>
            </div>
          </div>
          <div class="right"></div>
        </div>
      </div>
      <div class="content">
        <div  class="jumpEmaildiv">
          <span  class="jumpEmailSlect">已选 <span>{{handleSelectionList.length}}</span> 个</span>
          <span class="primaryBtn">
            <!-- :disabled="handleSelectionList.length==0" -->
            <el-button  size="small" class="smallBtn"  @click="jumpEmail" >发送邮件</el-button>
          </span>
        </div>
        <el-table
          class="fine-scroll-bar"
          size="small"
          width="100%"
          :data="tableData"
          @sort-change="sortChange"
          v-loading="loading"
          max-height="550px"
          tooltip-effect="light"
          @selection-change="handleSelectionChange"
        >
          <template slot="empty">
            <div class="no-content-slot"></div>
          </template>
          <el-table-column
            type="selection"
            width="55" align="center">
          </el-table-column>
          <!-- 客户名称 -->
          <el-table-column
            min-width="220"
            label="客户名称"
            class-name="table-column-companyName"
            fixed="left"
          >
            <template slot-scope="scope">
              <div class="table-item-specialFocus" @mousemove.prevent>
                <el-tooltip
                  effect="light"
                  :content="scope.row.companyName"
                  placement="bottom"
                  popper-class="customer-management-potential-companyName-tooltip"
                  :disabled="isShowTooltip"
                >
                  <p
                    class="table-item-specialFocus-name"
                    @mouseover="
                      onMouseOver('specialFocusStrTootip' + scope.$index)
                    "
                  >
                    <span
                      :ref="'specialFocusStrTootip' + scope.$index"
                      style="color: #066eb7; cursor: pointer; width: 80%"
                      @click="openDetail(scope.row.id, scope.$index)"
                    >
                      {{ scope.row.companyName | noText }}
                    </span>
                  </p>
                </el-tooltip>
                <i
                  class="iconfont icon-icon-shoucang"
                  v-if="scope.row.attentionStatus == 20"
                ></i>
              </div>
            </template>
          </el-table-column>
          <!-- 标签 -->
          <el-table-column prop="3" min-width="220" label="标签">
            <template slot-scope="scope">
              <el-popover
                placement="top-start"
                width="325"
                trigger="hover"
                v-if="scope.row.tagVos && scope.row.tagVos.length"
                popper-class="customer-management-tags-popover"
                :disabled="isShowTooltip"
              >
                <div class="table-item-tags-popover">
                  <span
                    v-for="item in scope.row.tagVos"
                    :key="item.id"
                    :style="{
                      backgroundColor: `rgba(${tagColors(item).rgb}, 0.1)`,
                      color: item.color,fontSize:`12px`,
                    }"
                    >{{ item.name }}</span
                  >
                </div>
                <div
                  class="table-item-tags"
                  @mouseover="onMouseOver('tagsStrTootip' + scope.$index)"
                  slot="reference"
                >
                  <span :ref="'tagsStrTootip' + scope.$index">
                    <span
                      v-for="item in scope.row.tagVos"
                      :key="item.id"
                      :style="{
                        backgroundColor: `rgba(${tagColors(item).rgb}, 0.1)`,
                        color: item.color,fontSize:`12px`,
                      }"
                      >{{ item.name }}</span
                    >
                  </span>
                </div>
              </el-popover>
              <span v-else>---</span>
            </template>
          </el-table-column>
          <!-- 主要联系人 -->
          <el-table-column min-width="120" label="联系人">
            <template slot-scope="scope">
              <el-popover
                popper-class="customer-management-potential-popover"
                v-if="scope.row.contacts && scope.row.contacts.length"
                placement="top-start"
                trigger="hover"
              >
                <div slot="reference">
                  {{ scope.row.contacts[0].contactName | noText }}
                </div>
                <div class="table-item-contacts fine-scroll-bar">
                  <div
                    class="li"
                    v-for="(item, index) in scope.row.contacts"
                    :key="index"
                  >
                    <div class="name">{{ item.contactName | noText }}</div>
                    <div class="mobile">
                      {{ item.mobile || item.tel ? item.areaCode : '' }}
                      {{ item.mobile || item.tel || '---' }}
                    </div>
                    <i
                      v-if="item.mobile || item.tel"
                      class="el-icon-document-copy"
                      v-copy="item.areaCode + ' ' + (item.mobile || item.tel)"
                    ></i>
                  </div>
                </div>
              </el-popover>
              <div v-else>---</div>
            </template>
          </el-table-column>
          <!-- 客户等级 -->
          <el-table-column
            prop="3"
            min-width="100"
            sortable="custom"
            label="客户等级"
          >
            <template slot-scope="scope">
              <div
                v-if="scope.row.levelShow"
                :style="'color:' + levelComp(scope.row.level).color"
              >
                {{ scope.row.levelShow | noText }}
              </div>
              <div v-else>---</div>
            </template>
          </el-table-column>
          <!-- 所属行业 -->
          <el-table-column min-width="150px" label="所属行业">
            <template slot-scope="scope">
              <div>
                {{ scope.row.industryStr | noText }}
              </div>
            </template>
          </el-table-column>
          <!-- 国家 -->
          <el-table-column min-width="100" label="国家">
            <template slot-scope="scope">
              <div>{{ scope.row.country | noText }}</div>
            </template>
          </el-table-column>
          <!-- 省份  -->
          <el-table-column min-width="100" label="省份">
            <template slot-scope="scope">
              <div>{{ scope.row.state | noText }}</div>
            </template>
          </el-table-column>
          <!-- 城市  -->
          <el-table-column min-width="120" label="城市">
            <template slot-scope="scope">
              <div>{{ scope.row.city | noText }}</div>
            </template>
          </el-table-column>
          <!-- 最近阅读邮件时间  -->
          <el-table-column
            prop="8"
            sortable="custom"
            min-width="180"
            label="最近阅读邮件时间"
          >
            <template slot-scope="scope">
              <div>
                {{ scope.row.recentlyReadTime | format('YYYY-MM-DD HH:mm') }}
              </div>
            </template>
          </el-table-column>
          <!-- 最后跟进时间  -->
          <el-table-column
            prop="2"
            sortable="custom"
            min-width="150"
            label="最后跟进时间"
          >
            <template slot-scope="scope">
              <div>
                {{ scope.row.lastFollowupTime | format('YYYY-MM-DD HH:mm') }}
              </div>
            </template>
          </el-table-column>
          <!-- 客户来源 -->
          <el-table-column min-width="100" label="客户来源">
            <template slot-scope="scope">
              <div>{{ scope.row.sourceShow | noText }}</div>
            </template>
          </el-table-column>
          <!-- 客户添加时间  -->
          <el-table-column
            prop="1"
            sortable="custom"
            min-width="170"
            label="客户添加时间"
          >
            <template slot-scope="scope">
              <div>{{ scope.row.createTime | format }}</div>
            </template>
          </el-table-column>
          <!-- 客户转为成交时间  -->
          <el-table-column
            prop="5"
            sortable="custom"
            min-width="170"
            label="客户转为成交时间"
          >
            <template slot-scope="scope">
              <div>
                {{ scope.row.transactionTime | format('YYYY-MM-DD HH:mm') }}
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="no-content" v-if="!tableData || !tableData.length">
          <img src="@/assets/image/common/noData.png" alt="" />
          <p>暂无数据</p>
        </div>
        <div class="pagination">
          <el-pagination
            v-show="total"
            background
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            @size-change="sizeChange"
            @current-change="currentChange"
            :page-sizes="[10, 20, 50, 100]"
            :current-page="curPage"
            :page-size="pageSize"
          >
          </el-pagination>
        </div>
      </div>
    </div>

    <!-- 客户详情 -->
    <DetailDrawer
      ref="detailDrawer"
      :companyDataProp="companyData"
      @emitAnewList="anewList"
    />
    <!-- 套餐购买 -->
    <vipBoxDialog :vipCode="vipCode" ref="vipBoxDialog" :typeOpen="false"/>
  </div>
</template>

<script>
import DetailDrawer from '@/components/custom/DetailDrawer'
import customerListMinxis from '@/mixins/customerList.js'
import { getSoldList } from '@/utils/api/customer.js'
import { sendEmailVerifyBulk,verifyBulkIdsConversion } from '@/utils/api/edmSubject'
import vipBoxDialog from "@/components/common/VIPdialog"
export default {
  components: {
    DetailDrawer,
    vipBoxDialog
  },
  mixins: [customerListMinxis],
  data() {
    return {
      tabPosition: '',
      isSpecialFocus: false,
      searchData: {
        keyword: '',
        tags: [], // 标签
        keySelectValue: 'keyword',
      },
      copySearchData: {},
      companyData: {
        id: null,
        ids: [],
        index: null,
      },
      handleSelectionList:[],
      vipCode:7002,//7001, "套餐可用额度不足" ,  7002, "套餐无可用额度
      sendEmailDis:true,
      uuid:'',
      
      curPage: 1,
      pageSize: 100
    }
  },
  methods: {
    // 表格多选
    handleSelectionChange(val) {
      console.log(val)
      this.handleSelectionList=[]
      val.map((item)=>{
        this.handleSelectionList.push(item.id)
      })
      console.log(this.handleSelectionList)
    },
    // 发送邮件
    jumpEmail(){
      if(this.handleSelectionList.length==0){
        this.$message.error('请至少选择一个客户')
      }else{
        if(this.sendEmailDis){
          this.sendEmailDis=false
          let params={
            ids:this.handleSelectionList
          }
          verifyBulkIdsConversion(params).then((res)=>{
            if(res.rspResult.bizCode==200){
              this.uuid=res.data.value
              let bodys={
                uuid:this.uuid
              }
              sendEmailVerifyBulk(bodys).then(res=>{
                if(res.rspResult.bizCode==200){
                  console.log(res)
                  let routeUrl = this.$router.resolve({
                    name:`clinchSendEmail`,
                    query:{
                      customerIds: this.uuid,
                    }
                  }).href
                  window.open(routeUrl, '_blank');
                  setTimeout(()=>{
                    this.sendEmailDis=true
                  },1000)
                }else if(res.rspResult.bizCode==7001||res.rspResult.bizCode==7002){
                  this.vipCode=res.rspResult.bizCode
                  this.$refs.vipBoxDialog.centerDialogVisible=true
                  setTimeout(()=>{
                    this.sendEmailDis=true
                  },1000)
                }else{
                  this.$message.error(res.rspResult.message)
                  setTimeout(()=>{
                    this.sendEmailDis=true
                  },1000)
                }
              })
            }else if(res.rspResult.bizCode==7001||res.rspResult.bizCode==7002){
              this.vipCode=res.rspResult.bizCode
              this.$refs.vipBoxDialog.centerDialogVisible=true
              setTimeout(()=>{
                this.sendEmailDis=true
              },1000)
            }else{
              this.$message.error(res.rspResult.message)
              setTimeout(()=>{
                this.sendEmailDis=true
              },1000)
            }

          })

        }
      }
    },
    // 获取列表数据
    async getList(isTop = true) {
      this.loading = true
      try {
        const params = {
          ...this.copySearchData,
          attentionStatus: this.attentionStatus || undefined, // 特别关注
          pageSize: this.pageSize,
          curPage: this.curPage,
          ...this.sort,
          // 以下代码清除不需要的入参，避免带入接口
          keyword: this.copySearchData.keyword,
          keySelectValue: undefined,
          companyName:undefined,
          // attribute:8
        }

        // 判断，如果选择的不是标签
        if (this.copySearchData.keySelectValue) {
          params.tags = undefined
          params[this.copySearchData.keySelectValue] =
            this.copySearchData.keyword.trim()
        }

        const res = await getSoldList(params)

        if (res.rspResult.bizCode === 200) {
          this.tableData = res.rspPageData.list
          this.total = res.rspPageData.totalNum
          if(isTop) this.returnTop()
        } else {
          this.total = 0
        }
        this.loading = false
      } catch (err) {
        this.total = 0
        this.loading = false
        console.error("❌ ~ file: clinch.vue:383 ~ getList ~ err:", err)
      }
    },
  },
  created() {
    this.copySearchData = JSON.parse(JSON.stringify(this.searchData))
    this.getList()
    this.getInitTagList()
  },
}
</script>

<style lang="scss" src="./style/potential.scss" scoped></style>
<style lang="scss" scoped>
.customer-management-clinch {
  .fixed {
    .left {
      .search-item {
        &:first-child {
          margin-right: 16px;
        }
      }
    }
  }
}
::v-deep .pagination{
  .el-pagination{
    .el-pagination__total{
      color: #4f5d78;
    }
  }
}
</style>
<style lang="scss">
.customer-management-clinch-companyName-tooltip.is-light[x-placement^='bottom']
  .popper__arrow {
  border-color: #ebeef5 !important;
}
.customer-management-tags-popover {
  padding-bottom: 0;
  max-height: 237px;
  overflow: auto;
  @import '@/assets/css/common.scss';
  @include fine-scroll-bar;
  .popper__arrow {
    display: none;
  }
}
.jumpEmaildiv{
  margin-left: 22px;
  margin-bottom: 12px;
  .jumpEmailSlect{
    font-size: 14px;
    color: #16181a;
    span{
      color: #066EB7;
      font-size: 14px;
    }
  }
  .primaryBtn{
    margin-left: 32px;
    font-size: 14px;
    color: #4F5D78;
    .smallBtn{
      font-size: 14px;
      color: #4F5D78;
    }
    .smallBtn:hover{
      font-size: 14px;
      color: #4F5D78;
      border: 1px solid #066eb7;
      background: #066eb71a;
      /* border-left-width: 0; */
      color: #066eb7;
    }
  }
}
</style>
